import { render, staticRenderFns } from "./BookOkPage.vue?vue&type=template&id=87a12678&"
import script from "./BookOkPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./BookOkPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CruiseBookPage.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports